import {NgModule} from "@angular/core";

import {MinioUrlPipe} from "./pipe/minio-url.pipe";
import {PhoneNumberPipe} from "./pipe/phone-number.pipe";
import {DateFormatPipe} from "./pipe/date-format.pipe";
import {PointDecimalPipe} from "./pipe/point-decimal.pipe";
import {DatePipe, DecimalPipe} from "@angular/common";

@NgModule({
    declarations: [
        MinioUrlPipe,
        PhoneNumberPipe,
        PointDecimalPipe,
        DateFormatPipe,
    ],
    imports: [],
    exports: [
        MinioUrlPipe,
        PhoneNumberPipe,
        PointDecimalPipe,
        DateFormatPipe,
    ],
    providers: [
        DecimalPipe,
        DatePipe
    ]
})
export class SharedModule {

}
